import ContainerSize from "../../Components/container";
const ShowClose =({content,handleToggle,show})=>{
    
return (
    <>

      <div className="py-10 bg-gray-100 ">
                <ContainerSize>
                    <div className="" >
                        {content.map((item, index) => (
                            <div
                                key={item.id}
                                className={`flex bg-white border border-gray-300 rounded-lg shadow-md p-4 mb-4 hover:shadow-lg ${show === index ? "" : "hover:bg-blue-200"
                                    } transition-shadow flex-col gap-2`}
                                onClick={() => handleToggle(index)}
                            >
                                {/* Header */}
                                <div className="flex justify-between px-6 items-center">
                                    <span className="flex gap-3 font-bold text-gray-700">
                                        <p>{item.id}.</p>
                                        <h3>{item.title}</h3>
                                    </span>
                                    <button>
                                        {show === index ? (
                                            <svg
                                                className="w-5 h-5 text-gray-800"
                                                aria-hidden="true"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    stroke="currentColor"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="m5 15 7-7 7 7"
                                                />
                                            </svg>
                                        ) : (
                                            <svg
                                                className="w-5 h-5 text-gray-800"
                                                aria-hidden="true"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    stroke="currentColor"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="m19 9-7 7-7-7"
                                                />
                                            </svg>
                                        )}
                                    </button>
                                </div>

                                {/* Content */}
                                {show === index && (
                                    <div className="px-10 py-2 text-gray-700 transition-all duration-500">
                                        {item.content.map((line, i) => (
                                            <p key={i} className="text-gray-700 mb-1">
                                                {line}
                                            </p>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </ContainerSize>
            </div>

    </>
)
}

export default ShowClose